import type { Meta, StoryObj } from "@storybook/web-components";
import { withActions } from "@storybook/addon-actions/decorator";
import { CreateServiceCall, CreateServiceCallProps } from "./CreateServiceCall";
import { NOTIFICATION_TYPES } from "../src/api/notificationType";
import { SALUTATION } from "../src/api/salutation";

// More on how to set up stories at: https://storybook.js.org/docs/writing-stories
const meta = {
    title: "CreateServiceCall",
    decorators: [withActions],
    component: "mf-create-service-call",
    tags: ["autodocs"],
    render: (args) => CreateServiceCall(args),
    argTypes: {
        multipleSteps: {
            control: { type: "boolean" }
        },
        fileUpload: {
            control: { type: "boolean" }
        },
        locale: {
            control: { type: "select" },
            options: ["de-DE", "en-US"]
        },
        salutation: {
            control: { type: "select" },
            options: Object.keys(SALUTATION)
        },
        firstName: {
            control: { type: "text" }
        },
        lastName: {
            control: { type: "text" }
        },
        email: {
            control: { type: "text" }
        },
        phone: {
            control: { type: "text" }
        },
        notificationTypeName: {
            control: { type: "select" },
            options: Object.keys(NOTIFICATION_TYPES)
        },
        errorNumbers: {
            control: { type: "text" }
        },
        onMfServiceCallSubmit: {
            action: "call-create"
        },
        onMfServiceCallCancel: {
            action: "call-cancel"
        },
        disableSilentAuth: {
            control: { type: "boolean" }
        }
    }
} satisfies Meta<CreateServiceCallProps>;

export default meta;
type Story = StoryObj<CreateServiceCallProps>;

export const OnePage: Story = {
    args: {
        multipleSteps: false,
        fileUpload: true,
        locale: "de-DE",
        disableSilentAuth: false
    }
};

export const MultiStep: Story = {
    args: {
        multipleSteps: true,
        fileUpload: true,
        locale: "en-US",
        disableSilentAuth: false
    }
};

export const WithContactData: Story = {
    args: {
        multipleSteps: false,
        locale: "de-DE",
        salutation: "MALE",
        firstName: "Max",
        lastName: "Mustermann",
        email: "example@trumpf.com",
        phone: "+49123456789",
        disableSilentAuth: false
    }
};
